import moment from 'moment';
import { getLocations } from '../Services/api-endpoints';
import { dateFormat } from '../../../common/utilities/utilitiesFunctions';

const todayDate = moment.utc().format(dateFormat);
export const getParsedLocations = async (effectiveDate = todayDate) => {
    const result = await getLocations(effectiveDate);
    return result.data;
}